export default function AquariumLogo({
    icon = "#ffffff",
    bg = "#0A6BCB",
    size = 100,
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="100" height="100" fill={bg} />

            <path
                d="M25.8647 52.0171C41.7477 22.8599 76.9539 24.1195 89.685 36.3511C89.6755 36.4439 87.7717 54.7289 64.3842 64.8325C47.1075 72.2756 30.2944 64.437 30.2944 64.437C27.9045 67.9753 26.9481 75.1614 15.7368 80.2759L19.6909 61.2046C17.6959 59.5812 11.8823 54.8468 4.58832 48.895C15.4522 46.142 20.1995 49.6105 25.8647 52.0171ZM66.6049 33.1226C63.5235 33.1226 61.025 35.6203 61.0248 38.7017C61.0248 41.7831 63.5235 44.2818 66.6049 44.2818C69.6862 44.2816 72.184 41.783 72.184 38.7017C72.1839 35.6205 69.6861 33.1228 66.6049 33.1226Z"
                fill={icon}
            />
        </svg>
    )
}
